import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";

function Section({ title, children }) {
  return (
    <section className="mb-10">
      <h2 className="font-mono text-base text-white uppercase tracking-wider mb-4 border-b border-[#2A2A2A] pb-3">
        {title}
      </h2>
      <div className="text-[#BEB3A6] font-sans leading-relaxed space-y-3 text-[0.95rem]">
        {children}
      </div>
    </section>
  );
}

export default function AboutPage() {
  return (
    <div className="bg-[#111111] min-h-screen">
      <Helmet>
        <title>About – Restricted Deals</title>
        <meta name="description" content="Restricted Deals is a free flight, hotel and cruise deal alert service based in the Netherlands. We find mistake fares and unlisted prices before they disappear." />
        <link rel="canonical" href="https://restricteddeals.com/about" />
      </Helmet>
      <SiteHeader />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <p className="eyebrow eyebrow-red mb-4">// ABOUT</p>
        <h1 className="font-mono text-4xl md:text-5xl text-white uppercase tracking-tight mb-14">
          Restricted Deals
        </h1>

        <Section title="// ABOUT RESTRICTED DEALS">
          <p>
            Restricted Deals is a free flight, hotel and cruise deal alert service based in the Netherlands.
          </p>
          <p>
            We find mistake fares, glitch fares and unlisted prices before they disappear — and send them straight to your inbox.
          </p>
        </Section>

        <Section title="// WHO WE ARE">
          <p>
            Restricted Deals is operated by an independent travel professional based in the Netherlands, with years of experience in the airline and travel industry.
          </p>
        </Section>

        <Section title="// WHAT WE DO">
          <p>
            We monitor flight prices, hotel rates and cruise deals daily across Europe, Asia, the Middle East and beyond. When we spot something genuinely exceptional — a price that shouldn't exist — we post it immediately.
          </p>
        </Section>

        <Section title="// FREE. ALWAYS.">
          <p>
            No subscription fee. No credit card. Unsubscribe with one click.
          </p>
        </Section>

        <Section title="// CONTACT">
          <p>For questions or enquiries:</p>
          <p>
            <a href="mailto:hello@restricteddeals.com" className="text-[#CC1A1A] hover:underline">
              hello@restricteddeals.com
            </a>
          </p>
          <p>
            <a href="https://restricteddeals.com" className="text-[#CC1A1A] hover:underline">
              restricteddeals.com
            </a>
          </p>
        </Section>

        <div className="hr-dot my-10" />
        <div className="flex gap-6 text-[11px] font-mono tracking-widest uppercase text-[#555]">
          <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-white transition-colors">Terms &amp; Conditions</Link>
          <Link to="/cookies" className="hover:text-white transition-colors">Cookie Policy</Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
